export const FooterLink2 = [
  {
    title: "Subjects",
    links: [
      { title: "Data Analytics", link: "/data-analytics" },
      { title: "Machine Learning", link: "/machine-learning" },
      { title: "DevOps", link: "/devops" },
      { title: "Web Development", link: "/web-development" },
      { title: "Mathematics", link: "/mathematics" },
      { title: "Game Development", link: "/game-development" },
      { title: "Cybersecurity", link: "/cybersecurity" },
      { title: "Cloud Computing", link: "/cloud-computing" },
      { title: "Artificial Intelligence", link: "/artificial-intelligence" },
      { title: "Mobile App Development", link: "/mobile-app-development" },
      { title: "Data Science", link: "/data-science" },
      { title: "Software Engineering", link: "/software-engineering" },
      { title: "Digital Marketing", link: "/digital-marketing" },
      { title: "Robotics", link: "/robotics" },
      { title: "Blockchain", link: "/blockchain" },
      { title: "UI/UX Design", link: "/ui-ux-design" },
    ],
  },
  {
    title: "Languages",
    links: [
      { title: "Go", link: "/go" },
      { title: "JavaScript", link: "/javascript" },
      { title: "Rust", link: "/rust" },
      { title: "TypeScript", link: "/typescript" },
      { title: "Dart", link: "/dart" },
      { title: "Scala", link: "/scala" },
      { title: "Swift", link: "/swift" },
      { title: "Kotlin", link: "/kotlin" },
      { title: "Ruby", link: "/ruby" },
      { title: "Python", link: "/python" },
      { title: "C++", link: "/c++" },
      { title: "Java", link: "/java" },
      { title: "PHP", link: "/php" },
      { title: "C#", link: "/csharp" },
      { title: "Bash", link: "/bash" },
      { title: "HTML & CSS", link: "/html-css" },
      { title: "SQL", link: "/sql" },
      { title: "R", link: "/r" },
    ],
  },
  
  {
    title: "Career Building",
    links: [
      { title: "Professional Development", link: "/professional-development" },
      { title: "Career Paths", link: "/career-paths" },
      { title: "Resume Building", link: "/resume-building" },
      { title: "Interview Prep", link: "/interview-prep" },
      { title: "Career Services", link: "/career-services" },
      { title: "Job Search", link: "/job-search" },
      { title: "Certification Programs", link: "/certification-programs" },
      { title: "Skill Enhancement", link: "/skill-enhancement" },
      { title: "Full Catalog", link: "/full-catalog" },
      { title: "Beta Content", link: "/beta-content" },
      { title: "Explore Opportunities", link: "/explore-opportunities" },
      { title: "Professional Growth", link: "/professional-growth" },
      { title: "Online Workshops", link: "/online-workshops" },
      { title: "Advanced Learning", link: "/advanced-learning" },
      { title: "Career Advancement", link: "/career-advancement" },
      { title: "Expert Guidance", link: "/expert-guidance" },
      { title: "-", link: "/hi" },
    ],
  }
  
  
];
